import { cn as e } from "../utils/index.js";
import * as t from "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/radio-tab.tsx
var r = ({ value: t, selectedValue: r = "", onChange: i, children: a, className: o = "", disabled: s = !1 }) => {
	let c = t === r;
	return /* @__PURE__ */ n("button", {
		type: "button",
		disabled: s,
		onClick: () => !s && i?.(t),
		"aria-pressed": c,
		className: e("relative inline-flex h-10 items-center justify-center min-w-[166px]", "gap-1", "border bg-white", "-ml-px first:ml-0", "first:rounded-l-[4px] last:rounded-r-[4px] [&:first-child>span]:rounded-l-[3px] [&:last-child>span]:rounded-r-[3px]", "transition-colors", "font-md-16 leading-6", !s && !c && "border-(--neutral-200) text-(--neutral-900) hover:text-(--seafoam-700)", !s && c && "bg-grad border-none z-10", s && "cursor-not-allowed border-(--neutral-200) bg-(--neutral-50) text-(--neutral-400)", "focus:outline-none focus-visible:ring-2 focus-visible:ring-(--seafoam-200)", o),
		style: c ? {
			color: "var(--seafoam-700)",
			borderColor: "var(--seafoam-700)"
		} : void 0,
		children: /* @__PURE__ */ n("span", {
			className: "bg-white px-4 py-[7px] w-[calc(100%-2px)]",
			children: a
		})
	});
}, i = ({ value: r, onChange: i, children: a, className: o = "" }) => {
	let s = t.Children.toArray(a).filter(Boolean);
	return /* @__PURE__ */ n("div", {
		className: e("inline-flex h-10 items-stretch", o),
		children: s.map((e) => t.isValidElement(e) ? t.cloneElement(e, {
			selectedValue: r,
			onChange: i
		}) : e)
	});
};
//#endregion
export { r as RadioTab, i as RadioTabGroup };
